import React from 'react';
import { motion } from 'framer-motion';
import './RACTimeline.css';

const RACTimeline = () => {
  console.log('[RACTimeline] Component rendered');
  
  const monitoringItems = [
    {
      icon: '📸',
      title: 'Photos/videos',
      description: 'Regular visual updates of your animal'
    },
    {
      icon: '❤️',
      title: 'Health status',
      description: 'Daily health monitoring and reports'
    },
    {
      icon: '🌾',
      title: 'Feeding logs',
      description: 'Detailed nutrition and feeding records'
    },
    {
      icon: '🥛',
      title: 'Milking updates',
      description: 'Daily milk production data'
    },
    {
      icon: '👨‍⚕️',
      title: 'Vet visits',
      description: 'Veterinary care and check-up records'
    },
    {
      icon: '📝',
      title: 'Activity notes',
      description: 'Comprehensive daily activity logs'
    }
  ];
  
  return (
    <section className="rac-timeline">
      <div className="rac-timeline-container">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="rac-section-title"
        >
          Daily Monitoring / Timeline
        </motion.h2>
        <div className="rac-gold-line"></div>
        
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="rac-timeline-intro"
        >
          This section emphasizes trust, transparency, and professionalism.
        </motion.p>
        
        <div className="rac-monitoring-grid">
          {monitoringItems.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="rac-monitoring-card"
            >
              <div className="rac-monitoring-icon">{item.icon}</div>
              <h3 className="rac-monitoring-title">{item.title}</h3>
              <p className="rac-monitoring-description">{item.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RACTimeline;



